export default __webpack_public_path__ + "static/media/product26.43f60229.png";